/**
 * Scrolls the current tag into view when the tag filter scrolls sideways (small screens), so you can see which tag
 * is selected. Only the bar itself moves, never the page.
 */
const list = document.querySelector('.blog-filter__list');
const current = list?.querySelector('[aria-current="true"]');

if (list instanceof HTMLElement && current instanceof HTMLElement && list.scrollWidth > list.clientWidth) {
  list.scrollLeft = current.offsetLeft - (list.clientWidth - current.offsetWidth) / 2;
}
